import classNames from "classnames";
import { useTranslation } from "react-i18next";

import DescriptionListItem from "@/components/Elements/DescriptionListItem";
import TextFieldPreview from "@/components/Elements/FieldPreview/TextFieldPreview";
import { ObservationItem } from "@/components/Observation/Observation.type";
import ObservationRecommendedInterventionsTable from "@/components/Observation/ObservationRecommendedInterventionsTable";
import { useThemeBreakpoints } from "@/services/theme";

import ObservationSummaryHeader from "./ObservationSummaryHeader";
import ObservationSummaryRiskMatrix from "./ObservationSummaryRiskMatrix";
import ObservationSummarySeverityGrid from "./ObservationSummarySeverityGrid";

import "./ObservationSummary.style.less";

const ObservationSummary = ({ observation }) => {
  const { t } = useTranslation();
  const { isXs } = useThemeBreakpoints();
  const { description } = observation;

  return (
    <div className={classNames("observation-summary", { "-xs": isXs })}>
      <ObservationSummaryHeader observation={observation} />
      <dl className="observation-description">
        <DescriptionListItem
          id="observation-description"
          label={t("observation:description")}
          content={<TextFieldPreview value={description} />}
        />
      </dl>
      <ObservationSummarySeverityGrid observation={observation} />
      <ObservationSummaryRiskMatrix observation={observation} />
      <ObservationRecommendedInterventionsTable observation={observation} />
    </div>
  );
};

ObservationSummary.propTypes = {
  observation: ObservationItem,
};

export default ObservationSummary;
